import { ref } from 'vue'
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import FileUpload from '@/components/file-upload'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'manage-section-form',
    components: {
        VueEditor, FileUpload
    },
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_patient: {
            type: Object,
            default: () => ({})
        },
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        selected_content: {
            type: Array,
            default: () => ([])
        },
        data_to_be_deleted: {
            type: Object,
            default: () => ({})
        },
        slug: String,
        liste_champs: Array,
        section_name: String,
    },

    data() {
        return {
            customToolbar: vueEditorToolbar,
            save_loading: false,
            is_loading: true,
            adm_is_loading: true,
            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            d_date: ref(new Date().toISOString().split('T')[0]),

            section_data: {
                v_model: []
            },

            selected_champ: [],
            o_occurence: [],
            filtered_occurence: [],

            can_show_micro: [],
            is_recording: ref(false),

            recognition: null,
            transcript: '',
            is_listening: false,
            recognition_err_msg: ''
        }
    },

    watch : {
        grs_toggler() {
            this.initFields()
            this.getListeAdmissions()
        }
    },

    computed: {
        liste_occurences() {
            return this.$store.getters["liste_occurences"];
        },

        liste_adimissions() {
            return this.$store.getters["liste_adimissions"];
        },
    },

    mounted() {
        this.$store.dispatch("getListeOccurences")
        
    },

    methods: {
        getListeAdmissions() {
            this.type_admissions = []
            this.adm_is_loading = true
            this.$store.dispatch("getListeTypeAdmission", 'admission').then((response) => {
                this.type_admissions = response;

                if (response.length === 0) {
                    this.is_empty = true;
                } else {
                    this.is_empty = false;
                }
                this.adm_is_loading = false;
            })
        },

        async initFields() {
            this.section_data = {
                v_model: []
            }
            this.is_loading = true
            let value  = ''
            let i = 0
            await this.liste_champs.forEach(c => {
                if (c.occurences.length > 0) {
                    value = []      // Array to hold multiple values
                } else {
                    value = ''      // Single value
                }
                this.section_data.v_model.push(
                    { value: value, field_name: c.champ, type: c.type_champ }
                );
                this.o_occurence.push('')
                this.selected_champ.push({selected_champ_occurences: []})

                if (c.type_champ == 'Editeur de texte') {
                    this.can_show_micro[i] = true
                }
                
                if (i == (this.liste_champs.length - 1)) {
                    this.is_loading = false
                }
                i++
            });
        },

        setVmodel(response) {
            this.section_data.v_model[response.c_index].value = response.u_file
        },

        addToOccurence_o(value, index) {
            this.o_occurence[index] = this.o_occurence[index].replace('_', '')

            this.filtered_occurence[index] = [];
            
            if (value.length >= 2) {
                this.liste_occurences.forEach(
                    el => {
                        if (el.occurence.toLowerCase().includes(value.toLowerCase())) {
                            this.filtered_occurence[index].push(el)
                        }
                    }
                )
            }
        },

        /**
         * Add a new occurence to the selected champ
         * @param {*} index 
         * @param {*} value 
         */
        addNewOccurence(index, value) {
            let j = 0

            let tmp_occurence = value

            // Verify if the occurence already exists
            this.selected_champ[index].selected_champ_occurences.forEach(occurence => {
                if (occurence.toLowerCase() == value.toLowerCase()) {
                    j++
                }
            });
            if (j == 0) {
                this.selected_champ[index].selected_champ_occurences.push(tmp_occurence)
                this.section_data.v_model[index].value.push(tmp_occurence)
                this.o_occurence[index] = ''
            }
            this.filtered_occurence[index] = []
        },

        /**
         * Add an existing occurence to the selected champ
         * @param {*} data 
         * @param {*} index 
         */
        addExistingOccurence(data, index) {
            let j = 0

            let tmp_occurence = ""
            this.liste_occurences.forEach(el => {
                if (data.occurence == el.occurence) {
                    tmp_occurence = el.occurence
                }
            });

            // Verify if the occurence already exists
            this.selected_champ[index].selected_champ_occurences.forEach(occurence => {
                if (occurence == data.occurence.toLowerCase()) {
                    j++
                }
            });

            if (j == 0) {
                this.selected_champ[index].selected_champ_occurences.push(tmp_occurence)
                this.section_data.v_model[index].value.push(tmp_occurence)
                this.o_occurence[index] = ''
            }

            this.filtered_occurence[index] = []
        },

        /**
         * Remove an occurence from the selected champ
         * @param {*} c_index 
         * @param {*} removal_index 
         */
        removeOccurence(c_index, removal_index) {
            this.selected_champ[c_index].selected_champ_occurences.splice(removal_index, 1)
            this.section_data.v_model[c_index].value.splice(removal_index, 1)
        },

        saveData() {
            this.permission_is_denied = false
            this.is_error = false

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: JSON.stringify(this.info_user),
                data_type: this.slug,
            }
            

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.section_data.v_model.forEach((champ, index) => {
                if (champ.value instanceof File) {
                    form_data.append(champ.field_name, champ.value);
                } else {    
                    form_data.append(`champs[${index}]`, JSON.stringify(champ));
                }
            });
            
            this.save_loading = true

            store_fiche.saveCustomSectionData(form_data).then((response) => {
                
                if (response.success) {
                    this.$refs.mdl_section_form.click()
                    this.$emit('emitRefreshSection')
                    this.successToast(response.message)

                    this.section_data = {
                        v_model: []
                    },

                    this.selected_champ = []
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.mdl_section_form.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerSection(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            store_fiche.deleteFicheSectionContent(this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès')
                    this.$emit("emitRefreshSection")

                    this.$refs.del_grp_sect.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        recordSpeech(input_selector, index) {
            this.recognition_err_msg = ''
            let area_focus = document.getElementById(input_selector+this.evolution_id)
            area_focus.focus()

            // Show the microphone for the current index and hide others
            this.can_show_micro[index] = true
            this.section_data.v_model.forEach((el, j) => {
                if (el.type == 'Editeur de texte') {
                    if (j != index) {
                        this.can_show_micro[j] = false
                    }
                }
            });

            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                this.recognition_err_msg = "La conversion Audio-Text n'est pas supportée par votre navigateur ! "+
                    "Merci d'utiliser un navigateur moderne comme Google Chrome ou Microsoft Edge."
                return
            }
            this.is_listening = true

            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'

            this.recognition.onresult = (evt) => {
                let interimTranscript = ''

                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.transcript = evt.results[i][0].transcript
                    if (evt.results[i].isFinal) {
                        this.section_data.v_model[index].value += this.transcript
                    } else {
                        interimTranscript += evt.results[i][0].transcript
                    }
                }
                console.log("Final : ",interimTranscript)
            }

            this.recognition.onerror = (evt) => {
                this.recognition_err_msg = "Une erreur est survenue lors de la conversion Audio-Text. "+
                    "Merci de vérifier votre connexion internet !"
                console.log("Speech recognition error: ",evt);
            }
            this.recognition.start()
        },

        stopRecording() {
            this.recognition_err_msg = ''
            this.recognition.stop();
            this.is_listening = false;
        
            // Restore all microphone icons to visible
            this.section_data.v_model.forEach((el, j) => {
                if (el.type == 'Editeur de texte') {
                    this.can_show_micro[j] = true
                }
            })
        
            // Optional: Clear the transcript if you want to start fresh next time
            this.transcript = ""; 
        }
    }
}